import {connect} from 'react-redux'

import type {State} from '../../../reducers/types'
import {getBuild} from '../../../selectors'

import type {BuildBranchOwnProps, BuildBranchStateProps} from './BranchLabel.types'
import BuildTypeBranchLabel from './BuildTypeBranchLabel.container'

const mapStateToProps = (state: State, props: BuildBranchOwnProps): BuildBranchStateProps => {
  const {branchName, defaultBranch, buildType} = getBuild(state, props.buildId) || {}
  return {
    main: defaultBranch,
    name: branchName,
    buildTypeId: buildType,
  }
}

export default connect(mapStateToProps, {})(BuildTypeBranchLabel)
